import React from 'react';
import classnames from 'classnames';

import { Link } from 'gatsby';
import ArrowSVG from '../../assets/images/arrow_back.svg';

import * as T from './TextHeader.types';
import * as S from './TextHeader.module.css';

export const TextHeader: React.FunctionComponent<T.ITextHeaderProps> = ({
  children,
  className,
  backHref,
}) => (
  <div className={S.header}>
    {backHref && (
      <Link to={backHref} className={S.back}>
        <ArrowSVG />
      </Link>
    )}
    <h2
      className={classnames(
        S.headerInner,
        {
          [S.withBackButton]: !!backHref,
        },
        className
      )}
    >
      {children}
    </h2>
  </div>
);
